















import { Component, Vue } from 'vue-property-decorator';
import AddressEditor from '@/components/registration/common/AddressEditor.vue';
import CreditCardEditor from '@/components/registration/common/CreditCardEditor.vue';
import { PaymentModel } from '@/interfaces/registration/models/PaymentModel';
import { RegistrationData } from '@/interfaces/registration/RegistrationData';
import { namespace } from 'vuex-class';
const registration = namespace('registration');

  @Component({
    components: { AddressEditor, CreditCardEditor }
  })
export default class PaymentInfoPanel extends Vue {
  public model: PaymentModel = {};

  mounted () {
    window.scrollTo(0, 0);
  }

  @registration.State
  public registrationData!: RegistrationData;
}
